import Cookies from "js-cookie";

import { CookieStorage } from "src/common/constants/storage";

export interface PaymentBuilderCookie {
  merchantName: string;
}

/**
 * Util for Spark's "Experience the product" experiment
 * https://gocardless.atlassian.net/browse/SPK-1139
 */
export const getPaymentBuilderData = (): PaymentBuilderCookie | null => {
  const data = Cookies.get(CookieStorage.PaymentBuilder);
  if (data) {
    return JSON.parse(data) as PaymentBuilderCookie;
  }
  return null;
};
